import React, { useState, useEffect, useRef } from "react";
import Chart from "react-apexcharts";

const ChartRenderer = ({ config, type, size }) => {
  const [chartType, setChartType] = useState(type || config.chart.type); // Track chart type
  const [chartKey, setChartKey] = useState(config.chart.type); // Key based on chart type
  const chartRef = useRef(null);

  if (config) {
    config.chart = {
      ...config.chart,
      events: {
        mounted: (chart) => {
          chartRef.current = chart; // Store the chart instance
        }
      }
    };
  }

  const getSeries = () => {
    if (type === "pie" || type === "donut") {
      return [30, 40, 35, 50, 49, 60, 70, 91];
    } else {
      return [
        {
          name: "Series 1",
          data: [
            { x: "Item 1", y: 10 },
            { x: "Item 2", y: 20 },
            { x: "Item 3", y: 15 },
            { x: "Item 4", y: 35 },
            { x: "Item 5", y: 40 },
            { x: "Item 6", y: 60 }
          ]
        }
      ];
    }
  };

  const series = getSeries();

  useEffect(() => {
    if (config.chart.type !== chartType) {
      setChartType(config.chart.type);
      setChartKey(config.chart.type);
    }
  }, [config.chart.type, chartType]);

  return (
    <div className={`chart-renderer ${size ? "preview" : ""}`}>
      <Chart
        key={chartKey}
        options={{ ...config }}
        series={series}
        height={size || config.height || 400}
        width={size || config.width || 400}
        type={type || config.chart.type}
      />
    </div>
  );
};

export default ChartRenderer;
